<template>
  <v-container fluid class="container">
    <div>
      <template v-if="loading">
        <v-row justify="center" align-content="center" class="mt-8">
          <img src="../../../assets/loading.gif" />
        </v-row>
      </template>
      <template v-else-if="topics.length > 0">
        <div :class="{'card-box': true, 'default-layout': isDefaultLayout, 'sm-layout': isSmLayout || isXsLayout}">
          <v-card
            v-for="(item, i) in topics" :key="i"
            :class="{'d-flex': true, 'flex-column': true, 'mt-8': true, 'default-card': isDefaultLayout}"
            width="268"
            min-width="268"
            height="369"
            outlined
          >
            <router-link
              :to="{ name: 'topic', params: { topic_code: item.topic_code } }"
              style="text-decoration: none"
            >
              <v-img
                class="white--text align-end"
                style="height: 170px"
                :src="`${bucketUrl}${item.topic_image_url}`"
              >
              </v-img>
            </router-link>

            <router-link
              :to="{ name: 'user', params: { user_code: item.user_code } }"
              style="text-decoration: none; color: inherit"
            >
              <v-card-subtitle class="pb-2 user-title">
                <v-avatar size="24" depressed>
                  <v-img :src="item.icon_url" width="24" height="24"></v-img>
                </v-avatar>
                <span class="ml-2 font-weight-bold">{{ item.user_name }}</span>
              </v-card-subtitle>
            </router-link>
            <v-card-text class="pt-0 overflow-auto">
              <router-link
                :to="{ name: 'topic', params: { topic_code: item.topic_code } }"
                class="font-weight-bold pt-0 mb-2"
                style="
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                  text-decoration: none;
                  color: black;
                "
              >{{ item.topic_name }}</router-link>
              <span v-for="tag in item.tags" :key="tag.tag_name" class="mr-2">
                <v-btn
                  depressed
                  dark
                  color="#333333"
                  @click="searchTag(tag.tag_name)"
                  x-small
                  class="font-weight-bold tag-name"
                  style="text-transform: none"
                >{{ tag.tag_name }}</v-btn>
              </span>
            </v-card-text>

            <v-spacer></v-spacer>
            <v-divider class=""></v-divider>
            <v-card-text class="pa-1">
              <v-row class="">
                <v-col cols="6" class="topic-updated-at" style="color: black; font-size: 10px;">
                  <time :datetime="formatDate(item.updated_at)">更新日：{{ formatDate(item.updated_at) }}</time>
                </v-col>
                <v-col cols="3" class="topic-preview-count" style="color: black; font-size: 14px;">
                  <v-icon size="16">mdi-eye</v-icon><span class="ml-1">{{ item.preview_count }}</span>
                </v-col>
                <v-col cols="3" class="topic-preview-count" style="color: black; font-size: 14px;">
                  <v-icon size="16">mdi-heart</v-icon><span class="ml-1">{{ item.lgtm }}</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </template>
      <template v-else>
        <p class="ml-10 mt-5">トピックは存在しません</p>
      </template>
    </div>
    <v-row class="mt-5 mx-4" :justify="isXsLayout ? 'center' : 'end'">
      <v-pagination
        class="my-5"
        v-model="crrent"
        :length="page"
        @input="getNumber"
        circle
        color="#5E00BC"
        :total-visible="7"
      ></v-pagination>
    </v-row>
  </v-container>
</template>

<script>
import dayjs from "dayjs";
import axios from "axios";

export default {
  name: "TopicList",
  data() {
    return {
      topics: [],
      topic_count: 0, // トピック総件数
      page: 0, // 表示ページ数
      crrent: 1, // 現在ページ
      loading: true,
      bucketUrl: process.env.VUE_APP_IMAGE_BUCKET_URL,
      drawer: false,
    };
  },
  props: ["column"],
  async mounted() {
    await this.getTopics();
  },
  methods: {
    searchTag($tag) {
      this.$router.push({ path: "/search_result", query: { tag: $tag } });
    },
    getTopics() {
      this.$store.dispatch("topicList/get", this.column).then(() => {
        this.topics = this.$store.getters["topicList/topics"];
        this.topic_count = this.$store.getters["topicList/topicCount"];
        this.setPaginate(this.topic_count);
        this.loading = false;
      });
    },
    setPaginate(totalCount) {
      this.page = Math.ceil(totalCount / 32);
    },
    getNumber(number) {
      axios
        .get(
          process.env.VUE_APP_API_BASE_URL + "/topic?skip=" + (number - 1) * 32
        )
        .then((response) => {
          this.topics = response.data.topics;
          this.total_count = response.data.total_count;
          this.current = number;
          this.loading = false;
        });
    },
    sort(event, column) {
      this.column = column;
      this.getTopics();
    },
    formatDate: (dateStr) => dayjs(dateStr).format("YYYY/MM/DD"),
  },
  watch: {
    column: function () {
			this.loading = true;
      this.getTopics();
    },
  },
  computed: {
    isSmLayout() {
      if (this.$vuetify.breakpoint.name === 'sm') {
        return true;
      }
      return false;
    },
    isXsLayout() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return true;
      }
      return false;
    },
    isDefaultLayout() {
      if (this.isSmLayout === false && this.isXsLayout === false) {
        return true;
      }
      return false;
    }
  },
  created() {
    document.title = 'vla.tips' 
    document.head.querySelector("meta[name=description]").setAttribute('content', 'vla.tipsは、散らばっているナレッジをひとつにする、URLのまとめサービスです。おすすめナレッジの共有、ノウハウ、メモ、ドキュメントを簡単に記録することができます。')
    document.querySelector("meta[property='og:title']").setAttribute('content', '散らばっているナレッジをひとつにまとめるサービス - vla.tips')
    document.querySelector("meta[property='og:description']").setAttribute('content', 'vla.tipsは、散らばっているナレッジをひとつにする、URLのまとめサービスです。おすすめナレッジの共有、ノウハウ、メモ、ドキュメントを簡単に記録することができます。')
    document.querySelector("meta[property='og:url']").setAttribute('content', 'https://vla.tips')
    document.querySelector("meta[property='og:image']").setAttribute('href', 'https://image.vla.tips/OGP.png')
    // twitter OGP
    document.querySelector("meta[name='twitter:title']").setAttribute('content', '散らばっているナレッジをひとつにまとめるサービス - vla.tips')
    document.querySelector("meta[name='twitter:description']").setAttribute('content', 'vla.tipsは、散らばっているナレッジをひとつにする、URLのまとめサービスです。おすすめナレッジの共有、ノウハウ、メモ、ドキュメントを簡単に記録することができます。')
    document.querySelector("meta[name='twitter:url']").setAttribute('content', 'https://vla.tips')
    document.querySelector("meta[name='twitter:image']").setAttribute('href', 'https://image.vla.tips/OGP.png')
  }

};
</script>

<style src="./TopicList.scss" lang="scss"></style>
<style scoped>
.container {
  padding: 0 !important;
}
.default-layout {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}
.sm-layout {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}
.default-card {
  margin-right: 2%;
}
.user-title:hover {
  background-color: #F4F4F4;
}
.tag-name:hover {
  color: #C388FF;
}
.topic-updated-at {
  padding: 12px 12px 12px 16px ;
}
.topic-preview-count {
  padding: 12px 0px 12px 0px ;
}
</style>
